module.exports = "::ng-deep .subject-editor .fr-box.fr-basic .fr-element {\n  padding: 10px 10px 4px 10px !important;\n  min-height: 4px !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/appointments/appointment-types/add-appointment-type/messages/subject-template/subject-template.component.scss
// module id = ./src/app/appointments/appointment-types/add-appointment-type/messages/subject-template/subject-template.component.scss
// module chunks = main